import { render, staticRenderFns } from "./ArrowDown.vue?vue&type=template&id=6636b0e7&"
import script from "./ArrowDown.vue?vue&type=script&setup=true&lang=js&"
export * from "./ArrowDown.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports